import { IWizardForm } from './wizard-form.component';
import { WizardService } from './wizard.service';

export const registrationForm: IWizardForm = {
  title: 'sessions.create.wizard.step1_2_registration.title',
  subscription: new WizardService().getRegistrationFormSubscription(),
  fields: []
};

export const preRegistrationForm: IWizardForm = {
  title: 'sessions.create.wizard.stepPreRegistration.title',
  subscription: new WizardService().getRegistrationFormSubscription(),
  fields: []
};



// WEBPACK FOOTER //
// ./src/app/modules/sessions/wizard/registration-form.ts